import React from "react";
import {
  Box,
  styled,
  Card,
  CardMedia,
  CardActions,
  IconButton,
} from "@mui/material";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import { Close, Visibility } from "@mui/icons-material";
import { ICreative } from "../../../interfaces/campaign";
interface IProps extends IWithClassName {
  files?: Array<File>;
  removeFile?: (file: File) => void;
  showPreview?: (file: File | ICreative) => void;
  serverFiles?: Array<ICreative>;
}

const Tiles = ({
  files,
  removeFile,
  showPreview,
  className,
  serverFiles,
}: IProps) => (
  <Box className={className}>
    {serverFiles?.map((serverFile) => (
      <Card key={serverFile.name}>
        <CardMedia
          component={
            serverFile.type && serverFile.type.includes("video")
              ? "video"
              : "img"
          }
          src={serverFile.url}
          autoPlay
        />
        {removeFile && showPreview && (
          <CardActions>
            {/* <IconButton onClick={() => removeFile(url)}>
                            <Close />
                        </IconButton> */}
            <IconButton onClick={() => showPreview(serverFile)}>
              <Visibility />
            </IconButton>
          </CardActions>
        )}
      </Card>
    ))}
    {files?.map((file) => (
      <Card key={file.name}>
        <CardMedia
          component={file.type.includes("video") ? "video" : "img"}
          src={URL.createObjectURL(file)}
          autoPlay
        />
        {removeFile && showPreview && (
          <CardActions>
            <IconButton onClick={() => removeFile(file)}>
              <Close />
            </IconButton>
            <IconButton onClick={() => showPreview(file)}>
              <Visibility />
            </IconButton>
          </CardActions>
        )}
      </Card>
    ))}
  </Box>
);

export default styled(Tiles)(({ theme }: IWithThemeProps) => ({
  display: "flex",
  gap: 10,
  ".MuiPaper-root": {
    display: "flex",
    ".MuiCardMedia-media": {
      maxWidth: 200,
      margin: "auto",
    },
  },
  ".MuiCardActions-root": {
    flexDirection: "column",
    justifyContent: "center",
    ".MuiIconButton-root": {
      margin: 0,
    },
    svg: {
      width: 25,
      height: 25,
    },
  },
}));
